module.exports = __webpack_public_path__ + "img/title1.21147e3b.png";